var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Movimiento de Stock","hide-footer":"","id":"stock-movement"}},[_c('stock-movement-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }